import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoanQuoteComponent } from './loan-quote/loan-quote.component';

const routes: Routes = [
  { path: '**', component: LoanQuoteComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
